import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatDistanceToNow } from 'date-fns'
import { ko } from 'date-fns/locale'

interface IWanderingNotificationProps {
    id: number
    userId: number
    userName: string
    distance?: number
    location?: {
        latitude: number
        longitude: number
    }
    timestamp?: string
    className?: string
    onClickLocation?: (latitude: number, longitude: number) => void
}

const WanderingNotification: React.FC<IWanderingNotificationProps> = ({
    userName,
    distance,
    location,
    timestamp,
    className,
    onClickLocation
}) => {
    const { t } = useTranslation()

    const getTimeAgo = () => {
        if (!timestamp) return ''
        try {
            return formatDistanceToNow(new Date(timestamp), { 
                addSuffix: true, 
                locale: ko 
            })
        } catch {
            return ''
        }
    }

    return (
        <div className={`bg-red-50 border-2 border-sub_r rounded-lg p-4 ${className || ''}`}>
            <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-sub_r rounded-full flex items-center justify-center animate-pulse">
                    <span className="text-2xl">🚨</span>
                </div>
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <p className="font-bold text-sub_r text-lg">{t('dashboard.notification.wanderingAlert')}</p>
                    </div>
                    <p className="font-bold text-gray-900 mb-1">{userName}님</p>
                    {distance !== undefined && (
                        <p className="text-sm text-gray-700 mb-1">
                            {t('dashboard.notification.distanceFromHome', { distance })}
                        </p>
                    )}
                    {timestamp && (
                        <p className="text-xs text-gray-500">{getTimeAgo()}</p>
                    )}
                </div>
            </div>
            {location && onClickLocation && (
                <button
                    className="w-full mt-3 py-2 bg-sub_r text-white rounded hover:bg-red-600 transition-colors font-medium"
                    onClick={() => onClickLocation(location.latitude, location.longitude)}
                >
                    {t('dashboard.notification.location')}
                </button>
            )}
        </div>
    )
}

export default WanderingNotification
